import React from "react";
import styles from "./LocationContent.module.scss";

export const longdo = window["longdo"];

export const longdoKey = "705359c28d78d98a08289c394cd2c36f";

export const AreaDataset = "IG";

export const ZoneType = {
  Area: "area",
  Point: "point",
};

export const ZoneColorLevel = {
  5: {
    fill: "rgba(250, 59, 59, 0.18)",
    line: "#FA3B3B",
  },
  4: {
    fill: "rgba(247, 136, 43, 0.18)",
    line: "#F7882B",
  },
  3: {
    fill: "rgba(253, 228, 51, 0.18)",
    line: "#FDE433",
  },
  2: {
    fill: "rgba(85, 185, 59, 0.18)",
    line: "#55B93B",
  },
  1: {
    line: "#086A95",
    fill: "rgba(8, 106, 149, 0.18)",
  },
  DotBorder: {
    line: "#fff",
  },
  Circle: {
    line: "rgba(255, 255, 255, 0)",
  },
  UserPosition: {
    fill: "rgba(65, 195, 219, 0.1)",
    line: "#41a1d8",
  },
};

export const LayerIcon = () => {
  return (
    <svg
      style={{ marginTop: "13%" }}
      width="20.785"
      height="23.705"
      viewBox="0 0 28.785 33.705"
    >
      <defs></defs>
      <g className={styles.layerIcon} transform="translate(1 0.716)">
        <path
          className={styles.path}
          d="M26.35,265.137l-3.431-2.45-7.544,5.387a3.281,3.281,0,0,1-3.964,0l-7.544-5.387-3.431,2.45a1.384,1.384,0,0,0,0,2.015l11.675,8.336a2.128,2.128,0,0,0,2.565,0l11.675-8.337a1.384,1.384,0,0,0,0-2.015Zm0,0"
          transform="translate(0 -250.832)"
        />
        <path
          className={styles.path}
          d="M26.35,422.282l-3.431-2.45-7.544,5.387a3.283,3.283,0,0,1-3.964,0l-7.544-5.387-3.431,2.45a1.384,1.384,0,0,0,0,2.015l11.675,8.336a2.127,2.127,0,0,0,2.565,0L26.35,424.3a1.384,1.384,0,0,0,0-2.015Zm0,0"
          transform="translate(0 -401.075)"
        />
        <path
          className={styles.path}
          d="M.435,11.115,12.11,19.451a2.127,2.127,0,0,0,2.565,0L26.35,11.115a1.243,1.243,0,0,0,.435-1.007A1.243,1.243,0,0,0,26.35,9.1L14.675.763a2.128,2.128,0,0,0-2.565,0L.435,9.1A1.243,1.243,0,0,0,0,10.107,1.243,1.243,0,0,0,.435,11.115Zm0,0"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg width="16" height="16">
      <path
        fill="#dcdcdc"
        d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4.2 10.8l-1.4 1.4L8 9.4l-2.8 2.8-1.4-1.4L6.6 8 3.8 5.2l1.4-1.4L8 6.6l2.8-2.8 1.4 1.4L9.4 8l2.8 2.8z"
      />
    </svg>
  );
};

export const DistanceIcon = () => {
  return (
    <svg width="6.914" height="7.903">
      <path
        fill="#006a95"
        d="M5.902.81a4.1 4.1 0 0 0-4.889 0 2.692 2.692 0 0 0-.321 3.9L3.457 7.9l2.766-3.192A2.692 2.692 0 0 0 5.902.81zM3.491 3.648a1.046 1.046 0 0 1-1.141-.912 1.046 1.046 0 0 1 1.141-.912 1.046 1.046 0 0 1 1.141.912 1.046 1.046 0 0 1-1.141.912z"
      />
    </svg>
  );
};

export const POIDefaultIcon = () => {
  return (
    <svg width="14.629" height="19.505">
      <path
        fill="#006a95"
        d="M7.315 0A7.323 7.323 0 0 0 0 7.315c0 5.4 6.749 11.81 7.036 12.081a.407.407 0 0 0 .557 0c.287-.271 7.036-6.684 7.036-12.081A7.323 7.323 0 0 0 7.315 0zm0 11.378a4.064 4.064 0 1 1 4.064-4.064 4.068 4.068 0 0 1-4.064 4.064z"
      />
    </svg>
  );
};

export const userMarker = `<svg width="18.809" height="26.904"><path fill="#cb001f" d="M16.055 2.754a9.4 9.4 0 0 0-13.3 0c-3.31 3.309-3.678 9.54-.878 13.284l7.528 10.861 7.523-10.865c2.808-3.74 2.436-9.971-.873-13.28zm-6.558 9.663a3.1 3.1 0 1 1 3.1-3.1 3.1 3.1 0 0 1-3.101 3.1z"/></svg>`;

// const fetchAddress = async (coordinate) => {
//   const res = await fetch(
//     `https://api.longdo.com/map/services/address?lon=${coordinate.lon}&lat=${coordinate.lat}&noelevation=1&locale=en&key=${longdoKey}`,
//     { method: "GET" }
//   );
//   const json = await res.json();
// };
